import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10.7992 3.63331C11.048 3.38512 11.048 2.98167 10.7992 2.73349C10.551 2.48467 10.1482 2.48467 9.89939 2.73349L6.76593 5.86694L3.63184 2.73349C3.38366 2.48467 2.98021 2.48467 2.73202 2.73349C2.48321 2.98167 2.48321 3.38512 2.73202 3.63331L5.86548 6.7674L2.73202 9.90085C2.48321 10.1497 2.48321 10.5525 2.73202 10.8007C2.98021 11.0495 3.38366 11.0495 3.63184 10.8007L6.76593 7.66722L9.89939 10.8007C10.1482 11.0495 10.551 11.0495 10.7992 10.8007C11.048 10.5525 11.048 10.1497 10.7992 9.90085L7.66575 6.7674L10.7992 3.63331Z",
  fill: "#FEFEFE"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render };